import { runtimeEnv } from "configuration";


export function joinUrl(...args: string[]) {
  if (args === undefined || args.length === 0)
    throw new Error("No segments provided");

  if (args.length === 1)
    return args[0];

  const result = [
    args[0].replace(/(\/$)/g, ""),
    ...args.slice(1).map((segment) => segment.replace(/(^\/|\/$)/g, ""))
  ];

  return result.filter(segment => segment).join("/");
}

export function getTargetOrigin() {
  return new URL(runtimeEnv.REACT_APP_COMPILER_URL).origin;
}
